import React from "react";
import {increaseArrayToIndex, removeByIndex} from "../../commons/Utils/ArrayUtils";
import EiaTextField from "../EiaTextField";
import {testShortFloatTwoDecimals} from "../../commons/Utils/RegExUtils";
import {Button, Flex, Icon, Label, SwitchField, View} from "@aws-amplify/ui-react";
import {RiAddBoxFill, RiDeleteBin6Line} from "react-icons/ri";
import EiaAutoComplete from "../EiaAutoComplete";
import EiaCard from "../cards/EiaCard";
import EiaSelect from "../EiaSelect";
import Utils from "../../commons/Utils/Utils";
import {AFFIXES} from "../../commons/enums/D4Affixes";
import {getStatValueSize} from "../../commons/Utils/StatUtils";

const isTouchScreen = Utils.isTouchScreen();
const invisibleLabel = <Label/>;

const getValueTextField = function (index, stat, updateStatValueFunction) {
    const thisFloatValue = stat && stat.floatValues && stat.floatValues.length > index ? stat.floatValues[index] : 0;
    return <EiaTextField key={index} errorMessage={"Enter number X_" + index + " (integer or float like 1.5)"} validator={testShortFloatTwoDecimals}
                         onChange={(e) => updateStatValueFunction(e.currentTarget.value, index)} value={thisFloatValue} hasError={thisFloatValue === ""}/>
}

//implicit stat or affix stat or aspect or unique stat selection
const D4ItemStatSelect = function (props) {
    const {statEnum, index, update, stats, onChange, setAlert, isGreaterAffixPossible, isMaxAspectPossible} = props;

    const effectiveStatEnum = statEnum === undefined ? AFFIXES : statEnum;
    const isStatAdded = stats !== undefined && index !== undefined && index !== null && index < stats.length
        && stats[index] !== undefined && stats[index] !== null;
    const thisStat = isStatAdded ? stats[index] : null;
    const thisStatName = thisStat ? thisStat.name : "";
    const statValuesSize = getStatValueSize(thisStat);
    let statValueIndexes = [];
    for (let i = 0; i < statValuesSize; i++) {
        statValueIndexes.push(i);
    }

    const greaterAffix = thisStat ? thisStat.greaterAffix : false;
    const maxAspect = thisStat ? thisStat.maxAspect : false;

    const [statNameFieldValue, setStatNameFieldValue] = React.useState("")

    React.useEffect(() => {
        setStatNameFieldValue(thisStatName);
    }, [update, stats]);

    const updateStatName = function (newNameValue, enumIndex) {
        let newStatName;
        if (enumIndex !== undefined) {
            newStatName = effectiveStatEnum[enumIndex];
        } else {
            newStatName = newNameValue;
        }

        setStatNameFieldValue(newNameValue);

        if (effectiveStatEnum.includes(newStatName)) {
            let newStats = Object.assign([], stats);
            updateStats(newStats, newStatName)
        }
    }

    const updateStatValue = function (newValue, index) {
        let newStats = Object.assign([], stats);
        updateStats(newStats, null, newValue, null, null, index);
    }

    const updateStatGreaterAffix = function (newValue) {
        let newStats = Object.assign([], stats);
        updateStats(newStats, null, null, newValue);
    }

    const updateStatMaxAspect = function (newValue) {
        let newStats = Object.assign([], stats);
        updateStats(newStats, null, null, null, newValue);
    }

    const updateStats = function (newStats, statName, value, greaterAffix, maxAspect, valueIndex) {
        let stat = newStats[index];
        if (!stat) {
            const newStat = {
                "name": statName,
                "floatValues": []
            }
            newStats[index] = newStat;
            stat = newStat;
        } else {
            if (statName) {
                stat.name = statName;
            }
        }

        if (value || value === 0) {
            stat.floatValues = increaseArrayToIndex(stat.floatValues, valueIndex)
            stat.floatValues[valueIndex] = value;
        }

        if (greaterAffix) {
            stat.greaterAffix = true;
        } else {
            stat.greaterAffix = false;
        }

        if (maxAspect) {
            stat.maxAspect = true;
        } else {
            stat.maxAspect = false;
        }

        onChange(newStats);
    }

    const addStat = function () {
        const initialStatName = "";
        setStatNameFieldValue(initialStatName);
        let newStats = Object.assign([], stats);
        updateStats(newStats, initialStatName, 0);
    }

    const removeStat = function () {
        let newStats = Object.assign([], stats);
        newStats = removeByIndex(newStats, index);
        onChange(newStats);
    }

    return (
        <EiaCard variation={"outlined"} roundCorners={true}>
            <Flex direction="column" justifyContent="space-between">
                {
                    isStatAdded ? null : <View>
                        <Button size={"large"} variation={"link"} onClick={addStat}>
                            <Icon ariaLabel="Javascript" as={RiAddBoxFill}/>

                        </Button>
                    </View>
                }
                {
                    isStatAdded ?
                        <div>
                            {
                                isTouchScreen ? <EiaSelect values={effectiveStatEnum} value={statNameFieldValue} onChange={(e) => updateStatName(null, e.target.value)}></EiaSelect>
                                    :
                                    <EiaAutoComplete title={"Stat"} values={effectiveStatEnum} value={statNameFieldValue} setValue={(value) => updateStatName(value)}/>
                            }
                            {
                                thisStatName && statValuesSize > 0 ?
                                    (
                                        statValuesSize === 1 ? getValueTextField(0, thisStat, updateStatValue) :
                                            <Flex direction={"row"}>
                                                {
                                                    statValueIndexes.map((index) => {
                                                        return getValueTextField(index, thisStat, updateStatValue);
                                                    })
                                                }
                                            </Flex>
                                    )
                                    : null
                            }
                            <View>
                                <Flex justifyContent={"space-between"}>
                                    {thisStatName && isGreaterAffixPossible ?
                                        <SwitchField
                                            label="Greater Affix"
                                            labelPosition="start"
                                            isChecked={greaterAffix}
                                            onChange={(e) => {
                                                updateStatGreaterAffix(e.target.checked);
                                            }}
                                        />
                                        : (isMaxAspectPossible ?
                                                <SwitchField
                                                    label="Max Aspect"
                                                    labelPosition="start"
                                                    isChecked={maxAspect}
                                                    onChange={(e) => {
                                                        updateStatMaxAspect(e.target.checked);
                                                    }}
                                                />
                                                : invisibleLabel
                                        )}
                                    <Button size={"large"} variation={"link"} onClick={removeStat}>
                                        <Icon ariaLabel="Javascript" as={RiDeleteBin6Line}/>
                                    </Button>
                                </Flex>
                            </View>
                        </div> : null
                }
            </Flex>
        </EiaCard>
    )
}
export default D4ItemStatSelect;